<template>
  <div>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/tableComponent.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <b-row>
    <b-col md="4" class="my-1">
      <b-form-group horizontal label="Filter" class="mb-0">
        <b-input-group>
          <b-form-input v-model="tableFilter" placeholder="Type to Search" />
          <b-input-group-append>
            <b-btn :disabled="!tableFilter" @click="tableFilter = ''">Clear</b-btn>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
    </b-col>
    <b-col md="4" class="my-1">
    <b-form-group horizontal label="Per page" class="mb-0">
      <b-form-select :options="pageOptions" v-model="perPage" />
    </b-form-group>
    </b-col>
    <b-col md="4" class="my-1">
      <b-pagination :total-rows="numrows" :per-page="perPage" v-model="tablePage" class="my-0" />
    </b-col>
    </b-row>
    <div id="eventInfo">
      <b-table responsive show-empty
        :items="items"
        :fields="fields"
        :current-page="tablePage"
        :per-page="perPage"
        :small="smallTable"
        :filter="tableFilter"
        @filtered="onTableFiltered"
      >
        <template v-slot:cell(source)="row">{{row.value.first}} {{row.value.last}}</template>
        <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template>
        <template v-slot:cell(actions)="row">
          <b-button size="sm"
            @click.stop="showSource(row.item, row.index, $event.target);
                        generateAll(row.item);
                        fetchColors(row.item);
                        checkIfBaseband(row.item)"
            class="mr-1">
            Select
          </b-button>
          <b-button size="sm" @click="notesSelected(row.item, row.index, $event.target)" v-b-modal.show-notes-modal>Show Notes</b-button>
          <b-button size="sm" @click="notesSelected(row.item, row.index, $event.target)" v-b-modal.take-notes-modal>Take Notes</b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'pageOptions',
    'numrows',
    'items',
    'fields',
    'perPage',
    'smallTable',
    'showSource',
    'generateAll',
    'checkIfBaseband',
    'fetchColors',
    'notesSelected'],
  data: function () {
    return {
      tableFilter: null,
      tablePage: 1
    }
  },
  methods: {
    onTableFiltered (filteredItems) {
      this.numrows = filteredItems.length
      this.tablePage = 1
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tableComponent.vue